'use client';

import React, { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import GlobalService from '@/api/services/GlobalService';
import {
  NotificationEnum,
  NotificationResponseType,
  NotificationType,
} from '@/api/services/GlobalService/types';

interface PromoData {
  title: string;
  description: string;
  imageUrl: string;
  submitUrl: string;
}

interface PromoProps {
  promo: PromoData;
}

const Promo: FC = () => {
  const [promo, setPromo] = useState<NotificationType | null>();

  const getNotifications = async () => {
    try {
      const data: NotificationResponseType = await GlobalService.post('NOTIFICATIONS_URL', null);

      if (data?.query?.length && typeof window !== 'undefined') {
        // @ts-ignore
        const notification: NotificationType | undefined = data.query.find(
          // @ts-ignore
          ({ type }) => type === NotificationEnum.PromoPopup
        );
        setPromo(notification);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const handleCloseNotificationPanel = () => {
    if (typeof window !== 'undefined') {
      setPromo(null);
      sessionStorage.setItem('hidePromoPopup', JSON.stringify(true));
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hidePromoPopup = sessionStorage.getItem('hidePromoPopup');
      !hidePromoPopup && getNotifications();
    }
  }, []);

  const { title, description, imageUrl, submitUrl } = promo || {};

  if (typeof window !== 'undefined' && promo) {
    return createPortal(
      <div className="popupPromoWrp">
        <div className="popupPromoHolder" style={{ backgroundImage: `url(${imageUrl})` }}>
          <div className="popupPromoInner">
            <div className="popupPromoCloseWrp">
              <i className="bc-i-close popupPromoClose" onClick={handleCloseNotificationPanel} />
            </div>
            <div className="popupPromoContentWrp">
              <p className="popupPromoTitle">{title}</p>
              <p className="popupPromoTxt">{description}</p>
              <div className="popupPromoBtnWrp">
                <div className="popupPromoBtnItem">
                  <button
                    className="button btnTypeBig btnTypeCopy fullWidth"
                    onClick={handleCloseNotificationPanel}
                  >
                    <p>Cancel</p>
                  </button>
                </div>
                <div className="popupPromoBtnItem">
                  <a href={submitUrl} className="button btnTypeBig btnTypeOrange fullWidth">
                    <p>Submit</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  return <div />;
};

export default Promo;
